import { Auth, API } from 'aws-amplify';

export const getAuthorisationLink = async () => {
	try {
		const currentSession = await Auth.currentSession();
		const jwtToken = currentSession.getIdToken().getJwtToken();
		return {
			headers: { authorization: `Bearer ${jwtToken}` }
		};
	} catch (err) {
		// eslint-disable-next-line no-console
		console.error('Getting token failed', err);
	}
};

export const getRequest = async (apiName, path) => {
	const response = API.get(apiName, path, await getAuthorisationLink()).catch((error) => {
		throw new Error(error.response.data.message);
	});
	return response;
};
